import { faqItems } from './faqItems';

export const features = [
  {
    name: 'A/B Testing Made Simple',
    description: 'Create multiple pricing table variations and test which one converts best. Our platform automatically generates unique combinations for maximum testing effectiveness.',
    icon: '🧪',
    href: '/signup',
  },
  {
    name: 'Smart Price Analysis',
    description: 'Upload your existing pricing table and our AI will automatically identify prices and replace them with dynamic placeholders for easy variation generation.',
    icon: '🤖',
    href: '/signup',
  },
  {
    name: 'Multi-Platform Support',
    description: 'Generate installation code for 12+ platforms including React, WordPress, PHP, Django, and more. One pricing table, everywhere you need it.',
    icon: '🌐',
    href: '/signup',
  },
  {
    name: 'Advanced Analytics',
    description: 'Track clicks, conversions, and user behavior with detailed analytics. Understand what drives your customers to convert.',
    icon: '📊',
    href: '/signup',
  },
];

/** First four match canonical FAQ copy; link to full FAQ page. */
export const faqs = faqItems.slice(0, 4).map((item, index) => ({
  id: index + 1,
  question: item.question,
  answer: item.answer,
  href: '/faq',
}));

/** Footer IA — see `publicNavBlueprint.ts` for top nav (Products / About). */
export const footerNavigation = {
  legal: [
    { name: 'Cookies', href: '/cookies' },
    { name: 'Terms of Service', href: '/terms-of-service' },
    { name: 'Privacy', href: '/privacy' },
  ],
  company: [
    { name: 'Careers', href: '/careers' },
    { name: 'Support', href: '/support' },
    { name: 'Marketing Assets', href: '/marketing-assets' },
  ],
};
